import Vue from 'vue'

import apis from '@/api'

const loadUserData = (page, pageSize, keyWord) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ALL_USERS,
      params: {
        page,
        pageSize,
        keyWord
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadDepartmentData = (deptId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DEPARTMENT_INFO,
      params: {
        deptId: deptId || ''
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadDeptUserData = (page, pageSize, deptId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DEPARTMENT_USERS,
      params: {
        deptId,
        page,
        pageSize
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadRoleData = () => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ROLE_INFO,
      params: {}
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadRoleUserData = (page, pageSize, roleId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ROLE_USERS,
      params: {
        page,
        pageSize,
        roleId
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

export default {
  editorConfigType: 'PEOPLE_SELECT_DEFAULT_VALUE',
  componentName: 'FormConfigPeopleSelectDefault',
  configProperty: 'userSelectDefaultValue',
  allowProperties: ['userSelectDefaultValue', 'defaultValue'],
  extras: {
    searchConfig: {
      loadData: loadUserData
    },
    personConfig: {
      loadData: loadUserData
    },
    departmentConfig: {
      nodekey: 'id',
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leafNodeFlag'
      },
      loadDepartmentData: loadDepartmentData,
      loadUserData: loadDeptUserData
    },
    roleConfig: {
      loadRoleData: loadRoleData,
      loadUserData: loadRoleUserData
    }
  }
}
